import React from 'react'

export const SeparatorSettings = (props) => <></>